import React, { useState } from "react";
import { Box, TextField, Typography } from "@mui/material"; // Fixed Typography import
import { DatePicker } from "@mui/x-date-pickers";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const DateRangePicker = ({
  startDate,
  endDate,
  handleStartDate,
  handleEndDate,
  size,
  isMobile, // Added prop here
}) => {
  const [isError, setIsError] = useState(false);
  const { t } = useTranslation();

  return (
    <Box 
      sx={{ 
        display: "flex", 
        // Column on mobile, Row on desktop
        flexDirection: isMobile ? "column" : "row", 
        alignItems: isMobile ? "flex-start" : "center",
        width: "100%"
      }}
    >
      <DatePicker
        label={t("walletcard.transactionpage.startdate")}
        value={startDate}
        onChange={handleStartDate}
        renderInput={(params) => (
          <TextField 
            {...params} 
            size={size} 
            sx={{ width: isMobile ? "100%" : "auto" }} 
          />
        )}
      />

      <Typography 
        sx={{ 
          color: process.env.REACT_APP_COLOR_TEXT, 
          fontSize: '1rem', 
          // Vertical margin on mobile, Horizontal margin on desktop
          my: isMobile ? 1 : 0, 
          mx: isMobile ? 0 : 2 
        }}
      >
        {t("walletcard.transactionpage.to") !== "walletcard.transactionpage.to" ? t("walletcard.transactionpage.to") : "to"}
      </Typography>
      
      <Box sx={{ width: isMobile ? "100%" : "auto" }}>
        <DatePicker
          label={t("walletcard.transactionpage.enddate")}
          value={endDate}
          onError={(error) => (error ? setIsError(true) : setIsError(false))}
          onChange={handleEndDate}
          renderInput={(params) => (
            <TextField
              {...params}
              error={isError}
              helperText={isError ? t("Date should not be in the past") : null}
              size={size}
              sx={{ width: isMobile ? "100%" : "auto" }}
            />
          )}
          minDate={startDate}
        />
      </Box>
    </Box>
  );
};

DateRangePicker.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  handleStartDate: PropTypes.func,
  handleEndDate: PropTypes.func,
  isMobile: PropTypes.bool, // Added to proptypes
};

DateRangePicker.defaultProps = {
  startDate: new Date(),
  endDate: new Date(),
  handleStartDate: () => null,
  handleEndDate: () => null,
  isMobile: false, // Default to desktop view
};

export default DateRangePicker;